import React, { useState, useEffect } from 'react'
import {useHistory} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import { v4 as uuidv4 } from 'uuid'
import validator from 'validator'
import { normalizeInput } from '../../utility/utils'



import DashboardHeader from './dashboardHeader'
import DashBoardContainer from '../../components/containers/dashboardContainer'
import HorizontalTextinput from '../../components/horizontalTextinput'
import {
    submitIndividualApplication,
    updateIndividualApplication, 
    fetchMembershipGrade,
    fetchIndividualApplicationReport,
    editMembership,
    validateMembershipNumber
} from '../../actions'
import {  
    SUBMIT_APPLICATION_ID,
    EDIT_MEMBERSHIP_LOADING_ID
} from '../../store/loaders'


const ApplicationReferenceDetails = (props)=>{

    const history = useHistory()
    const dispatch = useDispatch()
    
    const apiResponse = useSelector(state=>{
        const {loader,
            hasUpdatedIndividualApplication,
            membershipGrade,
            individualApplicationReport,
            hasEditedMembership,
            validateMembership
        } = state
        const {isLoading} = loader[SUBMIT_APPLICATION_ID] || {isLoading: false}
        const {application} = individualApplicationReport
        const {message} = hasUpdatedIndividualApplication
        const {grades} = membershipGrade
        const {edited} = hasEditedMembership
        const editLoader = loader[EDIT_MEMBERSHIP_LOADING_ID] || false
        const {data} = validateMembership
        return{
            isLoading,
            application,
            message,
            grades,
            editLoader,
            edited,
            data
        }
    })

    const actionLoader = apiResponse.isLoading
    const applicationId = apiResponse.application?.applicationId || apiResponse.application?.id
    const appId = props.location.state && props.location.state.application?.id
    const isMember = props.location.state && props.location.state?.isMember


    const [showProfessionItem, setProfessionalItem] = useState(true)
    const [addProfessionalBtn, setProfessionalBtn] = useState(true)

    const [showAcademicItem, setAcademicItem] = useState(true)
    const [addAcademicBtn, setAcademicBtn] = useState(true)


    //Professional References
    const [professionalFullNames,
        setprofessionalFullNames] = useState('')
    const [professionalMemberGrade,
        setProfessionalMemberGrade] = useState('')
    const [professionalIerNumber, 
        setprofessionalIerNumber] = useState('')
    const [requestId, 
            setRequestId] = useState('')

    //Academic References

    const [academicNames, 
        setAcademicNames] = useState('')
    const [academicPhoneNumber, 
        setAcademicPhoneNumber] = useState('')
    const [academicEmail, 
        setAcademicEmail] = useState('')
    const [academicIerNumber, 
        setAcademicIerNumber] = useState('')
    const [newAcademicReferenceArr, 
        setNewAcademicReferenceArr] = useState([])

    const [newProfessionalReferenceArr,
        setProfessionalReferenceArr] = useState([])

    const [ierNumberError, setIerNumberError] = useState(false)
    const [ierNumberHelperText, setIerNumberHelperText] = useState('')

    const [emailError, setEmailError] = useState(false)
    const [emailHelperText, setEmailHelperText] = useState('')
    const [invalid, setInvalid] = useState(false)

    const [phoneError, setphoneError] = useState(false)
    const [phoneErrorText, setPhoneErrorText] = useState(false)
    const [cacheId, setCacheId] = useState('')


    const [applicationDetails,
        setApplicationDetails] = useState({
            professionalReferences:[],
            academicReferences:[],
    })

    useEffect(()=>{
        dispatch(fetchMembershipGrade())
        if(isMember){
            setApplicationDetails(props.location.state.application)
            if(props.location.state.application?.professionalReferences?.length > 0){
                setProfessionalReferenceArr(props.location.state.application?.professionalReferences)
                setProfessionalItem(false)
            }
            if(props.location.state.application?.academicReferences?.length > 0){
                setNewAcademicReferenceArr(props.location.state.application?.academicReferences)
                setAcademicItem(false)
            }
        }
    },[])

    useEffect(()=>{
            dispatch(fetchIndividualApplicationReport(appId))
        if(apiResponse.message === requestId){
            history.push('/dashboard')
        }
    },[apiResponse.message])

    useEffect(()=>{
        if(apiResponse.edited === requestId){
        history.push({
            pathname: '/membership',
            state: {
                // application: applicationDetails
            }
        })
        }
    },[apiResponse.edited])

    useEffect(()=>{
        if(apiResponse.data?.status === 200 && apiResponse.data?.id === cacheId){
            setprofessionalFullNames(apiResponse.data?.data?.name)
            setProfessionalMemberGrade(apiResponse.data?.data?.membershipClass?.name)
            setIerNumberError(false)
            setIerNumberHelperText("")
        }
        if(apiResponse.data?.status === 204){
            setIerNumberError(true)
            setIerNumberHelperText("No content found")
            setprofessionalFullNames('')
            setProfessionalMemberGrade('')
        }
    },[apiResponse.data])

    useEffect(()=>{
        if(!isMember){
            if(apiResponse.application){
                setApplicationDetails({
                    ...apiResponse.application
                })
                setProfessionalItem(false)
                setAcademicItem(false)
            }
        }
        if(apiResponse.application?.professionalReferences?.length > 0){
            setProfessionalReferenceArr(apiResponse.application.professionalReferences)
        }
        if(apiResponse.application?.academicReferences?.length > 0){
            setNewAcademicReferenceArr(apiResponse.application.academicReferences)
        }
    },[apiResponse.application])

    const handleProfessionalNames = (text)=>{
        setprofessionalFullNames(text.target.value)
    }
    const handleProfessionalGrade = (text)=>{
        setProfessionalMemberGrade(text.label)
    }


    const debounce = (cb, delay = 1000)=>{
        let timeout 
        return (...args) => {
            timeout = ''
            timeout = setTimeout(() =>{
                cb(...args)
            }, delay)
        }
    }
    const updateDebounce = debounce((text)=>{
        console.log("what we have", text.target.value)
        var id = uuidv4()
        setCacheId(id)
        dispatch(validateMembershipNumber({value: text.target.value, id}))
    },1000)

    const handleProfessionalIerNumber = (text)=>{
        setIerNumberError(false)
        setIerNumberHelperText("")
        var id = uuidv4()
        setCacheId(id)
        dispatch(validateMembershipNumber({value: text.target.value, id:id }))
        setprofessionalIerNumber(text.target.value)
    }

    const handleAcademicNames = (text)=>{
        setAcademicNames(text.target.value)
    }

    const handleAcademicEmail = (text)=>{
        setAcademicEmail(text.target.value)
        setEmailHelperText('')
        setEmailError(false)
    }

    const handleAcademicPhone = (text)=>{
        setAcademicPhoneNumber(normalizeInput(text.target.value, academicPhoneNumber))
        setphoneError(false)
            setPhoneErrorText('')
    }

    const handleNewAcademicReference = ()=>{
        if(academicNames === '' || academicPhoneNumber === '' || academicEmail === '' ){
            return 
        }
        setNewAcademicReferenceArr([...newAcademicReferenceArr,{
            academicNames,
            academicPhoneNumber,
            academicEmail,
            academicIerNumber
        }])
        setAcademicIerNumber('')
        setAcademicNames('')
        setAcademicPhoneNumber('')
        setAcademicEmail('')
    }

    const deleteAcademicReference = (id)=>{
        var deletedItem 
        deletedItem = newAcademicReferenceArr.filter(function(el,index){
            return index !== id
        })
        setNewAcademicReferenceArr(deletedItem)
    }

    var membershipOptions 
    if(apiResponse.grades?.length> 0){
        membershipOptions = apiResponse.grades.map(value=>{
            return{value: value.id, label: value.name}
        })
    }

    const handleShowAcademicItems = ()=>{
        setAcademicBtn(false)
        setAcademicItem(true)
    }

    var displayAcademicReferenceArr
    if(newAcademicReferenceArr.length>0){
        displayAcademicReferenceArr = newAcademicReferenceArr.map((value,id)=>{
            return(
                <div className="dashboarder-grey-contanier mt-4 mb-4">
                    <div style={{width: '30%'}}>
                        <HorizontalTextinput 
                        title="Names"
                        disabled={true}
                        handleChange={handleAcademicNames}
                        value={value.academicNames || value.name}/>
                    </div>
                    <div style={{width: '30%'}}>
                        <HorizontalTextinput 
                        title="Phone"
                        disabled={true}
                        handleChange={handleAcademicPhone}
                        value={value.academicPhoneNumber || value.telephoneNumber}/>
                    </div>
                    <div style={{width: '30%'}}>
                        <HorizontalTextinput 
                        title="Email"
                        disabled={true}
                        handleChange={handleAcademicEmail}
                        value={value.academicEmail || value.email}/>
                    </div>                    
                    <div className="addition-container-circle mt-4">
                        <div className="addition-red-ctn mt-2" onClick={()=>deleteAcademicReference(id)}>
                            <span>-</span>
                        </div>
                        {/* {id === 0 && addAcademicBtn && <div className="addition-blue-ctn mt-2" onClick={()=>handleShowAcademicItems()}>
                                    <span>+</span>
                            </div>} */}
                    </div>
                </div>
            )
        })
    }




    const handleAddNewProffessionalReference = ()=>{
        if(professionalFullNames === '' || professionalMemberGrade === '' || professionalIerNumber === ''){
            return
        }
        setProfessionalReferenceArr([...newProfessionalReferenceArr, {
            professionalFullNames, 
            professionalMemberGrade,
            professionalIerNumber
        }])
        setprofessionalFullNames('')
        setProfessionalMemberGrade('')
        setprofessionalIerNumber('')
    }
    
    const deleteProfessionalReference = (id)=>{
        var deletedItem 
        deletedItem = newProfessionalReferenceArr.filter(function(el,index){
            return index !== id
        })
        setProfessionalReferenceArr(deletedItem)
    }


    const handleShowProfessionalItems = ()=>{
        setProfessionalBtn(false)
        setProfessionalItem(true)
    }


    var disiplayNewProfessionalReference
    if(newProfessionalReferenceArr.length > 0){
        disiplayNewProfessionalReference = newProfessionalReferenceArr.map((value,id)=>{
            return(
                <div className="dashboarder-grey-contanier">
                    <div style={{width: '30%'}}>
                        <HorizontalTextinput 
                            title="Full names"
                            handleChange={handleProfessionalNames}
                            value={value.professionalFullNames || value.name}
                            disabled={true}
                            />
                    </div>
                    <div style={{width: '22%'}}>
                        <HorizontalTextinput 
                            title="Member Grade"
                            handleChange={handleProfessionalGrade}
                            value={value.professionalMemberGrade || value.memberGradeId}
                            disabled={true}/>
                    </div>
                    <div style={{width: '30%'}}>
                        <HorizontalTextinput 
                            title="IER Member Number"
                            handleChange={handleProfessionalIerNumber}
                            value={value.professionalIerNumber || value.ierMemberNumber}
                            disabled={true}/>
                    </div>
                    <div className="addition-container-circle mt-4">
                        <div className="addition-red-ctn mt-2" onClick={()=>deleteProfessionalReference(id)}>
                            <span>-</span>
                        </div>
                        {/* {id === 0 && addProfessionalBtn && <div className="addition-blue-ctn mt-2" onClick={()=>handleShowProfessionalItems()}>
                                    <span>+</span>
                        </div>} */}
                    </div>
                </div>
            )
        })
    }

    var professionalReferenceArr = []
    if(professionalIerNumber !== '' && professionalMemberGrade !== '' && professionalFullNames !== ''){
        professionalReferenceArr.push({
            ierMemberNumber: professionalIerNumber,
            memberGradeId: professionalMemberGrade,
            name: professionalFullNames
        })
    }

    if(newProfessionalReferenceArr.length > 0) {
        newProfessionalReferenceArr.map(value=>{
            professionalReferenceArr.push({
                ierMemberNumber: value.professionalIerNumber || value.name,
                memberGradeId: value.professionalMemberGrade || value.memberGradeId,
                name: value.professionalFullNames || value.ierMemberNumber
            })
        })
    }

    var academicReferenceArr = []
    if(academicEmail !== '' && academicNames !== '' && academicPhoneNumber !== ''){
        academicReferenceArr.push({
            email: academicEmail,
            ierMemberNumber: academicIerNumber,
            name: academicNames,
            telephoneNumber: academicPhoneNumber
        })
    }

    if(newAcademicReferenceArr.length > 0) {
        newAcademicReferenceArr.map(value=>{
            academicReferenceArr.push({
                email: value.academicEmail || value.email,
                ierMemberNumber: value.academicIerNumber || value.ierMemberNumber,
                name: value.academicNames || value.name,
                telephoneNumber: value.academicPhoneNumber || value.telephoneNumber
            })
        })
    }

    const handleSaveForLater = ()=>{
        if(invalid){
            return
        }
        const reqId = uuidv4()
        setRequestId(reqId)
        const sendData= {
            ...applicationDetails,
            academicReferences:academicReferenceArr,
            professionalReferences: professionalReferenceArr,
            step:6,
        }
        if(isMember){
            const sentItems = {
                academicReferences:academicReferenceArr,
                professionalReferences: professionalReferenceArr,
            }
            dispatch(editMembership({
                id: appId, 
                application: sentItems,
                reqId : reqId
            }))
            return
        }
        if(applicationId){
            dispatch(updateIndividualApplication({
                data:{
                    ...sendData
                },
                id: applicationId,
                reqId : reqId
            }))
        } 
        else{
            dispatch(submitIndividualApplication({
                data:{
                    ...sendData
                },
                reqId:reqId
            }))
        }
    }

    const handleSubmit = ()=>{
        if(invalid){
            return
        }
        history.push({
            pathname: '/applicant/review-details',
            state: {
                application: applicationDetails
            }
        })
        handleSaveForLater()
    }

    const handleCancel = ()=>{
        history.push({
            pathname: '/applicant/certificate-details',
            state: {
                application: applicationDetails
            }
        })
     }

     const handleMembership = () =>{
        handleSaveForLater()

     }

     const handleOnBlur = () =>{
        if(!validator.isEmail(academicEmail)){
            setEmailError(true)
            setEmailHelperText('Invalid Email')
            setInvalid(true)
            return
        }
        setInvalid(false)
    }

     const handlePhoneValidation = (phone) =>{
        if(phone&&  phone.length < 6){
            setphoneError(true)
            setPhoneErrorText('invalid input')
     }
    }

    const handleCloseMembership = ()=>{
        history.goBack()
    }
    return (
        <div>
            {!isMember &&<DashboardHeader 
                activeStep={6}
                application={applicationDetails}
                />}
        <DashBoardContainer
                handleSubmit={handleSubmit}
                handleCancel={handleCancel}
                handleSaveForLater={handleSaveForLater}
                title="Next"
                disabled={actionLoader}
                // payLoader={actionLoader}
                loader={actionLoader}
                middleTitle="Save for Later"
                hasCloseBtn={isMember ? true: false}
                hasButton={isMember ? true: false}
                closeTitle="Submit"
                handleClose={handleMembership}
                editLoader={apiResponse.editLoader?.isLoading}
                handleCloseMembership={handleCloseMembership}
                >
               {/* {    applicationDetails.membershipClassId?.name === 'Professional/Corporate Engineer' ||
                    applicationDetails.membershipClassId?.name === 'Fellow' ||
                    applicationDetails.membershipClassId?.name === 'Honorary' ?
               <> */}
               <div className="d-flex w-100" style={{
                    alignItems: 'center',
                    justifyContent: 'space-between'}}>
                    <div></div>
                    <span className="dashboard-green-text-header">
                        Professional References 
                    </span>
                    <div>
                        {applicationDetails.professionalReferences?.length > 0  && addProfessionalBtn && <div className="addition-container-circle mb-4" style={{width: 80}} onClick={()=>handleShowProfessionalItems()}>
                                <div className="addition-blue-ctn mt-2">
                                    <span>+</span>
                                </div>
                            </div>}
                    </div>
                    
                </div>
                 {applicationDetails.professionalReferences?.length <= 0 || showProfessionItem ? <div className="dashboarder-grey-contanier mb-4">
                        <div style={{width: '30%'}}>
                            <HorizontalTextinput 
                                title="IER Member Number"
                                handleChange={(text)=>handleProfessionalIerNumber(text)}
                                value={professionalIerNumber}
                                placeholder="Ex: B001/GC/IER/2021"
                                error={ierNumberError}
                                helperText={ierNumberHelperText}
                                required={true}

                                />
                        </div>
                        <div style={{width: '30%'}}>
                            <HorizontalTextinput 
                                title="Full names"
                                handleChange={handleProfessionalNames}
                                value={professionalFullNames}
                                disabled={true}
                                required={true}
                                />
                        </div>
                        <div style={{width: '22%'}}>
                            <HorizontalTextinput 
                                title="Member Grade"
                                handleChange={handleProfessionalGrade}
                                value={professionalMemberGrade}
                                options={membershipOptions}
                                disabled={true}
                                required={true}
                                />
                        </div>
                       
                        <div className="addition-container-circle">
                            <div className="addition-blue-ctn mt-4" onClick={handleAddNewProffessionalReference}>
                                <span>+</span>
                            </div>
                        </div>
                    </div> : null }
                    
                   { disiplayNewProfessionalReference }

                    <div className="d-flex mt-4" style={{
                        alignItems: 'center',
                        justifyContent: 'space-between'
                        }}>
                        <div></div>
                        <span className="dashboard-green-text-header">
                            Academic References 
                        </span>
                        <div>
                        {applicationDetails.academicReferences?.length > 0  && addAcademicBtn && <div className="addition-container-circle" style={{width: 80}} onClick={()=>handleShowAcademicItems()}>
                            <div className="addition-blue-ctn mt-2">
                                <span>+</span>
                            </div>
                        </div>}
                        </div>
                    </div>

                  {applicationDetails.academicReferences?.length <= 0 || showAcademicItem ? <div className="dashboarder-grey-contanier mt-4 mb-4">
                        <div style={{width: '30%'}}>
                        <HorizontalTextinput 
                            title="Names"
                            handleChange={handleAcademicNames}
                            value={academicNames}
                            type="text"
                            required={true}

                            />
                        </div>
                        <div style={{width: '30%'}}>
                            <HorizontalTextinput 
                            title="Phone"
                            handleChange={handleAcademicPhone}
                            type="tel"
                            value={academicPhoneNumber}
                            onBlur={()=>handlePhoneValidation(academicPhoneNumber)}
                            error={phoneError}
                            helperText={phoneErrorText}
                            required={true}

                            />
                        </div>
                        <div style={{width: '30%'}}>
                            <HorizontalTextinput 
                                title="Email"
                                handleChange={handleAcademicEmail}
                                value={academicEmail}
                                type="email"
                                error={emailError}
                                helperText={emailHelperText}
                                onBlur={handleOnBlur}
                                required={true}
                            />
                        </div>
                        <div className="addition-container-circle" onClick={handleNewAcademicReference}>
                            <div className="addition-blue-ctn mt-4">
                                <span>+</span>
                            </div>
                        </div>
                    </div> : null}
                    {displayAcademicReferenceArr}
            </DashBoardContainer>
        </div>
    )
}

export default ApplicationReferenceDetails